import React from 'react';
import Slick from 'react-slick';
import styled from 'styled-components';
import { observer, inject } from 'mobx-react';

import video1 from './video/1.mp4';
import video2 from './video/2.mp4';
import video3 from './video/3.mp4';
import video4 from './video/4.mp4';

import Slide from './components/Slide';
import { clearfix, toVw, toVwMobile, toVwTablet } from '../../../../utils/styles';
import mq from '@/utils/media-queries';
import debounce from 'lodash/debounce';
import { SLIDE_SIZE_DESKTOP, SLIDE_SIZE_MOBILE, SLIDE_SIZE_TABLET } from './constants';

const SETTINGS = {
  infinite: true,
  speed: 500,
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: false,
  centerMode: true,
  variableWidth: true,
  centerPadding: [0],
};

const ITEMS = [
  {
    media: {
      type: 'video',
      content: {
        assets: [
          {
            path: video1,
            type: 'mp4',
          },
        ],
      },
    },
    text: 'Firstly, researching a company, market and auditory',
  },
  {
    media: {
      type: 'video',
      content: {
        assets: [
          {
            path: video2,
            type: 'mp4',
          },
        ],
      },
    },
    text: 'Secondly, developing creative idea and strategy',
  },
  {
    media: {
      type: 'video',
      content: {
        assets: [
          {
            path: video3,
            type: 'mp4',
          },
        ],
      },
    },
    text: 'Thirdly, creating identity and transfer it into digital',
  },
  {
    media: {
      type: 'video',
      content: {
        assets: [
          {
            path: video4,
            type: 'mp4',
          },
        ],
      },
    },
    text: 'Last, communication, ads campaign and social media',
  },
];

const Styled = styled.div`
  height: ${toVw(SLIDE_SIZE_DESKTOP)};

  ${mq.tablet(css`
    height: ${toVwTablet(SLIDE_SIZE_TABLET)};
  `)};

  ${mq.mobile(css`
    height: ${toVwMobile(SLIDE_SIZE_MOBILE)};
  `)};

  .slick-list {
    overflow: visible;
  }

  .slick-track {
    ${clearfix};
  }
`;

const SlideWrapper = styled.div`
  width: ${toVw(SLIDE_SIZE_DESKTOP)};
  height: ${toVw(SLIDE_SIZE_DESKTOP)};
  padding: 0 18px;
  will-change: opacity;

  ${mq.tablet(css`
    width: ${toVwTablet(SLIDE_SIZE_TABLET)};
    height: ${toVwTablet(SLIDE_SIZE_TABLET)};
  `)};

  ${mq.mobile(css`
    width: ${toVwMobile(SLIDE_SIZE_MOBILE)};
    height: ${toVwMobile(SLIDE_SIZE_MOBILE)};
  `)};
`;

class Carousel extends React.Component {
  state = {
    currentIndex: 0,
  };

  componentDidMount() {
    this.updateValues();
    window.addEventListener('resize', this.resizeHandler);
    this.containerNode.addEventListener('touchstart', this.touchstartHandler);
    this.containerNode.addEventListener('touchmove', this.touchmoveHandler);
    this.handleNonDraggableElements();
  }

  handleNonDraggableElements = () => {
    const elements = this.containerNode.querySelectorAll('a video img');
    const events = ['dragstart', 'dragend', 'touchmove'];
    elements.forEach(el => events.forEach(eventName => el.addEventListener(eventName, this.preventDefaultHandler)));
  };

  componentWillUnmount() {
    window.removeEventListener('resize', this.resizeHandler);
  }

  preventDefaultHandler = e => e.preventDefault();

  touchstartHandler = e => {
    let touches;
    if (e.touches !== undefined) {
      touches = e.touches[0];
    }
    this._startX = touches !== undefined ? touches.pageX : e.clientX;
  };

  touchmoveHandler = e => {
    let touches;
    if (e.touches !== undefined) {
      touches = e.touches[0];
    }
    this._currX = touches !== undefined ? touches.pageX : e.clientX;
    let swipeLength = Math.round(Math.sqrt(Math.pow(this._currX - this._startX, 2)));
    if (swipeLength > 4) {
      e.preventDefault();
    }
  };

  resizeHandler = debounce(() => {
    this.updateValues();
  }, 200);

  calculateMousePositionRatio = x => x / this.windowWidth;

  checkIfSlideIsCurrent = slide => {
    return slide.classList.contains('slick-active');
  };

  handleSlideMouseEnter = e => {
    const slickSlide = e.currentTarget.parentNode;
    if (this.checkIfSlideIsCurrent(slickSlide)) {
      this.props.cursorStore.setNone();
      return;
    }

    const ratio = this.calculateMousePositionRatio(e.clientX);

    if (ratio < 0.5) {
      this.props.cursorStore.setPrev();
    } else {
      this.props.cursorStore.setNext();
    }
  };

  handleSlideMouseLeave = () => {
    this.props.cursorStore.setNone();
  };

  handleSlideClick = e => {
    const slickSlide = e.currentTarget.parentNode;
    if (this.checkIfSlideIsCurrent(slickSlide)) {
      this.props.cursorStore.setNone();
      return;
    }

    const ratio = this.calculateMousePositionRatio(e.clientX);

    if (ratio < 0.5) {
      this.slick.slickPrev();
    } else {
      this.slick.slickNext();
    }
  };

  updateValues() {
    this.windowWidth = window.innerWidth;
  }

  render() {
    const { className } = this.props;

    return (
      <Styled className={className} innerRef={node => (this.containerNode = node)}>
        <Slick
          {...SETTINGS}
          afterChange={currentIndex => this.setState({ currentIndex })}
          ref={node => (this.slick = node)}
        >
          {ITEMS.map((item, index) => (
            <SlideWrapper key={index}>
              <Slide
                {...item}
                active={index === this.state.currentIndex}
                onMouseEnter={this.handleSlideMouseEnter}
                onMouseLeave={this.handleSlideMouseLeave}
                onClick={this.handleSlideClick}
              />
            </SlideWrapper>
          ))}
        </Slick>
      </Styled>
    );
  }
}

export default inject(stores => ({ cursorStore: stores.store.cursorStore }))(observer(Carousel));



// WEBPACK FOOTER //
// ./src/scenes/Approach/components/Carousel/index.js